/**
 * SSOT — gallery URLs for hotel customer offer surfaces (public link + guest sale).
 */

import { buildPublicHotelImageBundle } from "./publicHotelBookingImages";
import { buildHotelSearchCardHeroImageUrls } from "./hotelSearchListDisplay";
import { coerceGenericImagesToUrlList } from "./hotelProfileGalleryUrls";

export function normalizeHotelGalleryImageUrl(value) {
  if (value == null) return "";
  if (typeof value === "string") {
    const normalized = coerceGenericImagesToUrlList([value.trim()]);
    return normalized[0] || "";
  }
  if (Array.isArray(value)) {
    for (const item of value) {
      const resolved = normalizeHotelGalleryImageUrl(item);
      if (resolved) return resolved;
    }
    return "";
  }
  if (typeof value === "object") {
    return normalizeHotelGalleryImageUrl(
      value.url ??
        value.src ??
        value.image ??
        value.imageUrl ??
        value.imageurl ??
        value.ImageUrl ??
        value.FullSize ??
        value.fullSize ??
        value.thumbnail ??
        value.href
    );
  }
  return "";
}

export function mergeHotelOfferGalleryImages(...sources) {
  const raw = [];
  const push = (value) => {
    if (value == null) return;
    if (Array.isArray(value)) {
      value.forEach(push);
      return;
    }
    raw.push(value);
  };
  sources.forEach(push);
  return coerceGenericImagesToUrlList(raw);
}

/** @param {object|null|undefined} currentHotelOrder */
export function resolveHotelOfferGalleryImagesFromOrder(currentHotelOrder) {
  if (!currentHotelOrder) return [];
  const selectedHotel = currentHotelOrder?.selectedHotel;
  const bundle = buildPublicHotelImageBundle({
    selectedHotel,
    selectedRoom: currentHotelOrder?.selectedRoom,
    selectedPackage: currentHotelOrder?.selectedHotelPackage,
    galleryImages: currentHotelOrder?.galleryImages,
    hotelImage: currentHotelOrder?.hotelImage,
    roomImage: currentHotelOrder?.roomImage,
  });
  return mergeHotelOfferGalleryImages(
    bundle.galleryImages,
    bundle.hotelImage,
    bundle.roomImage,
    currentHotelOrder?.profileGalleryImages,
    buildHotelSearchCardHeroImageUrls(selectedHotel),
    selectedHotel?.Images,
    selectedHotel?.DefaultImage,
    currentHotelOrder?.selectedRoom?.images,
    selectedHotel?.images
  ).slice(0, 24);
}

/** @param {object|null|undefined} payload stored public-offer payload */
export function resolveHotelOfferGalleryImagesFromPublicPayload(payload) {
  const root = payload && typeof payload === "object" ? payload : {};
  const vm =
    root.public_view_model && typeof root.public_view_model === "object"
      ? root.public_view_model
      : {};
  const selection =
    root.selection && typeof root.selection === "object" ? root.selection : {};
  const selectedRoom =
    selection.selected_room && typeof selection.selected_room === "object"
      ? selection.selected_room
      : {};
  const selectedPackage =
    selection.selected_package && typeof selection.selected_package === "object"
      ? selection.selected_package
      : {};
  const hotel =
    root.hotel && typeof root.hotel === "object"
      ? root.hotel
      : vm.hotel && typeof vm.hotel === "object"
        ? vm.hotel
        : {};

  return mergeHotelOfferGalleryImages(
    vm.galleryImages,
    vm.gallery_images,
    root.galleryImages,
    root.gallery_images,
    root.profileGalleryImages,
    root.profile_gallery_images,
    root.hotelImage,
    root.roomImage,
    selectedRoom.images,
    selectedPackage.images,
    hotel.images,
    hotel.Images,
    hotel.DefaultImage,
    buildHotelSearchCardHeroImageUrls(hotel),
    vm.heroImage,
    vm.heroImageUrl,
    vm.hotelImage,
    root.heroImage
  ).slice(0, 24);
}
